import React from 'react';
import DocsAndNotes from '../../../DocsAndNotes';

const DocumentsAndNotesDetail = ({meta}) => {
    return (
        <DocsAndNotes meta={meta}/>
    );
};

export default DocumentsAndNotesDetail;